export const skinLayoutHWOption = {
    id: "player-con",
    source: "",
    width: "100%",
    height: "420px",
    autoplay: true,
    isLive: false,
    rePlay: true,
    videoHeight: "530px",
    playsinline: true,
    preload: true,
    controlBarVisibility: "click",
    videoWidth: "262px",
    showBarTime: 2000,
    useH5Prism: true,
    skinLayout: [{
            name: "errorDisplay",
            align: "tlabs",
            x: 0,
            y: 0
        },
        {
            name: "controlBar",
            align: "blabs",
            x: 0,
            y: 0,
            children: [{
                    name: "progress",
                    align: "blabs",
                    x: 0,
                    y: 44
                },
                {
                    name: "playButton",
                    align: "tl",
                    x: 15,
                    y: 12
                }
            ]
        }
    ]
}